export default () => localStorage.removeItem('sessionData')
